// import CookieTipModal from "@components/CookieTipModal";
// import TimesLimitModal from "@components/TimesLimitModal";
import { useAppDispatch, useAppSelector } from "@hooks/redux";
import GlobalAccountCrowd from "@layouts/GlobalAccountCrowd";
// import GlobalNotify from "@layouts/GlobalNotify";
import GlobalRecaptcha from "@layouts/GlobalRecaptcha";
import GlobalVideoModal from "@layouts/GlobalVideoModal";
import OrderSuccess from "@layouts/OrderSuccess";
import VideoDonwloading from "@layouts/VideoDonwloading";
import LoginLimitModal from "@pages/home/login/LoginLimitModal";
// import ShoppingCart from "@pages/pricing/layouts/ShoppingCart";
import useTitleTranslate from "@hooks/useTitleTranslate";
import TitleTranslateModal from "@components/TitleTranslateModal";
import GlobalTrashModal from "@layouts/GlobalTrashModal";
import GlobalChromeNotifyPermission from "@layouts/GlobalChromeNotifyPermission";
import { useEffect } from "react";
import { initLoginMethod, updateLoginMethod, updateSignupMethod, initSignupMethod } from "@store/globalSlice";
import ShoppingCart from "@layouts/ShoppingCart";
// import GetMembershipModal from "@layouts/GetMembershipModal";

export default () => {
  const { showTranslateModal } = useTitleTranslate();
  const { language } = useAppSelector((state) => state.globalReducer);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (location.pathname.includes("/signup")) {
      dispatch(updateSignupMethod(initSignupMethod() as "sms" | "email" | "wxcode"));
      return;
    }
    dispatch(updateLoginMethod(initLoginMethod()));
  }, [language]);

  return (
    <>
      {/* 全局视频播放弹窗 */}
      <GlobalVideoModal></GlobalVideoModal>
      {/* 视频脚本下载进度显示 */}
      <VideoDonwloading></VideoDonwloading>
      {/* 会员套餐购物车弹窗 */}
      <ShoppingCart></ShoppingCart>
      {/* 订单成功弹窗 */}
      <OrderSuccess></OrderSuccess>
      {/* 全局人机验证 */}
      <GlobalRecaptcha></GlobalRecaptcha>
      {/* 全局通知弹窗 */}
      {/* <GlobalNotify></GlobalNotify> */}
      {/* 全局Cookie提示弹窗 */}
      {/* <CookieTipModal></CookieTipModal> */}
      {/* 使用次数限制提示 */}
      {/* <TimesLimitModal></TimesLimitModal> */}
      {/* 设备登录限制提示 */}
      <LoginLimitModal />
      {/* 全局账号拥挤提示 */}
      <GlobalAccountCrowd />
      {/* 全局标题翻译弹窗 */}
      {showTranslateModal && <TitleTranslateModal open={showTranslateModal} />}
      {/* 全局回收站弹窗 */}
      <GlobalTrashModal />
      {/* 全局通知权限引导弹窗 */}
      <GlobalChromeNotifyPermission />
      {/* 新人会员领取弹窗 */}
      {/* <GetMembershipModal /> */}
    </>
  );
};
